import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import { BASE_URL } from '../config';
import SEO from '../components/SEO';
import './Membership.css';

// 获取隐私链接
const getPrivacyLink = async (imageUrl) => {
  try {
    console.log('正在获取图片隐私链接:', imageUrl);
    const response = await fetch(`${BASE_URL}/privacy_link?img_url=${encodeURIComponent(imageUrl)}`);
    const data = await response.json();
    console.log('获取到的隐私链接响应:', data);
    if (typeof data === 'string') {
      return data; // 直接返回URL字符串
    }
    return data.link || data; // 返回link字段或整个响应
  } catch (error) {
    console.error('获取隐私链接失败:', error, '图片URL:', imageUrl);
    return imageUrl; // 如果获取失败，返回原始URL
  }
};

const Membership = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMemberships = async () => {
      try {
        console.log('开始获取会员服务数据');
        const response = await fetch(`${BASE_URL}/memberships`);
        if (!response.ok) {
          throw new Error(`获取会员服务数据失败: ${response.status} ${response.statusText}`);
        }
        const data = await response.json();
        console.log('获取到的会员服务数据:', data);
        
        // 处理课程图片
        const processedCourses = await Promise.all(
          data.map(async (course) => {
            console.log('处理课程图片:', course.title);
            const privacyLink = await getPrivacyLink(course.course_image);
            console.log('处理后的图片链接:', privacyLink);
            return {
              ...course,
              course_image: privacyLink
            };
          })
        );
        setCourses(processedCourses);
      } catch (error) {
        console.error('获取会员服务数据失败:', error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchMemberships();
  }, []);

  if (loading) {
    return <div className="loading">加载中...</div>;
  }

  if (error) {
    return <div className="error">错误：{error}</div>;
  }

  return (
    <div className="membership-container">
      <SEO page="membership" />
      <Header />
      <main className="main-content full-width">
        <h1 className="page-title">会员服务</h1>
        <div className="course-list">
          {courses.map(course => (
            <div key={course.id} className="course-card">
              <img
                src={course.course_image || '/images/default-img-cover.png'}
                alt={course.title}
                className="course-image"
                width="300"
                height="200"
                loading="lazy"
                onError={(e) => {
                  console.error('图片加载失败:', {
                    src: e.target.src,
                    courseTitle: course.title,
                    originalSrc: course.course_image
                  });
                  e.target.onerror = null;
                  e.target.src = '/images/default-img-cover.png';
                }}
                onLoad={(e) => {
                  console.log('图片加载成功:', {
                    src: e.target.src,
                    courseTitle: course.title
                  });
                }}
              />
              <div className="course-content">
                <h3 className="course-title">{course.title}</h3>
                <div className="course-meta">
                  <span>时长：{course.duration}</span>
                  <span>时间：{course.time}</span>
                  <span>年龄：{course.age}</span>
                </div>
                <p className="course-description">{course.description}</p>
                <div className="course-price">{course.price}</div>
                <div className="course-actions">
                  <button className="course-button" onClick={() => window.location.href='/registration'}>立即报名</button>
                  <button className="course-button secondary">查看详情</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
};

export default Membership;
